import { render, staticRenderFns } from "./FolderCard.vue?vue&type=template&id=0af70c99&scoped=true&"
import script from "./FolderCard.vue?vue&type=script&lang=ts&"
export * from "./FolderCard.vue?vue&type=script&lang=ts&"
import style0 from "./FolderCard.vue?vue&type=style&index=0&id=0af70c99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af70c99",
  null
  
)

export default component.exports